import {findIconDefinition, IconName, IconPrefix, library} from '@fortawesome/fontawesome-svg-core'
import {loadIconBucket} from 'virtual:font-awesome-icon-buckets'
import {ref} from 'vue'

const registeredIconsVersion = ref(0)
const pendingIconLoads = new Map<string, Promise<void>>()

export function isFontAwesomeIconRegistered(prefix: IconPrefix, iconName: string): boolean {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  registeredIconsVersion.value
  return !!findIconDefinition({
    prefix,
    iconName: iconName as IconName,
  })
}

export function loadFontAwesomeIcon(prefix: IconPrefix, iconName: string): Promise<void> {
  const iconKey = `${prefix}:${iconName}`
  const pendingIconLoad = pendingIconLoads.get(iconKey)
  if(pendingIconLoad) {
    return pendingIconLoad
  }
  const bucket = isFontAwesomeIconRegistered(prefix, iconName) ? null : loadIconBucket(prefix, iconName)
  if(!bucket) {
    return Promise.resolve()
  }
  const iconLoad = bucket
    .then((icons) => {
      library.add(...icons)
      registeredIconsVersion.value++
    })
    .catch(() => {
      pendingIconLoads.delete(iconKey)
    })
  pendingIconLoads.set(iconKey, iconLoad)
  return iconLoad
}
